export default "__VITE_ASSET__abb63d2b__"